import * as React from "react";
import { last } from "lodash";
import { useParameter, useDictionaryItem } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideTitle() {
  const [commodities] = useParameter<number[]>("@commodities_display");
  const [business] = useParameter<number>("@business-units");
  const [commName, setCommName] = React.useState("");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: Number(business),
    slide: 6,
  });
  React.useEffect(() => {
    if (commodityItem && commodityName) {
      setCommName(commodityName[9]);
    }
  }, [commodityItem, commodityName]);

  const bname = (business || 1) === 2 ? "APE" : "AP";

  const title = `${bname} major crops by lead countries (incl. forecast) – ${commName} area, production and yield`;
  return title;
}
